import injectionCode from '../../../preview/advanced-checkout'

const type = 'advanced'
const path = '/advance/react-node/advanced-integration/public/'
const name = 'index.html'

export { type, path, name, injectionCode }
